import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import { InputWithConfirm, RadioOptionsWithConfirm, IQuestion } from 'shared-components';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const VisaPrepFormDeclarationsPage1 = (_props: any) => {
    const { t } = useTranslation('common');
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE6));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));
  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);

  // state props from store
  const studentVisaPrepForm = useSelector(({ student }: ApplicationState) => student.visa, shallowEqual);
  const {
    hasCriminalCharges,
    hasTerrorismInvolvement,
    hasTerrorismConnection,
    hasTerrorismJustified,
    hasWarCrimes,
    hasBadActivities,
    language,
  } = studentVisaPrepForm;

  // constants
  const currentStep = 1;
  const steps = 1;

  // component state
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      hasCriminalCharges,
      hasTerrorismInvolvement,
      hasTerrorismConnection,
      hasTerrorismJustified,
      hasWarCrimes,
      hasBadActivities,
      language,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [
    complete,
    hasCriminalCharges,
    hasTerrorismInvolvement,
    hasTerrorismConnection,
    hasTerrorismJustified,
    hasWarCrimes,
    hasBadActivities,
    language,
  ]);

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Declarations'}
    >
      <RadioOptionsWithConfirm
        key={VQ.HAS_CRIMINAL_CHARGES}
        id={VQ.HAS_CRIMINAL_CHARGES}
        label={t('common:haveYouEverBeenChargedInAnyCount')}
        onClick={(question: IQuestion) => onChange(VQ.HAS_CRIMINAL_CHARGES, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: hasCriminalCharges === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: hasCriminalCharges === false,
          },
        ]}
      />

      <RadioOptionsWithConfirm
        key={VQ.HAS_TERRORISM_INVOLVEMENT}
        id={VQ.HAS_TERRORISM_INVOLVEMENT}
        label={t('common:haveYouEverBeenInvolvedInSupport')}
        onClick={(question: IQuestion) => onChange(VQ.HAS_TERRORISM_INVOLVEMENT, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: hasTerrorismInvolvement === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: hasTerrorismInvolvement === false,
          },
        ]}
      />

      <RadioOptionsWithConfirm
        key={VQ.HAS_TERRORISM_CONNECTION}
        id={VQ.HAS_TERRORISM_CONNECTION}
        label={t('common:haveYouEverBeenAMemberOfOrGivenS')}
        onClick={(question: IQuestion) => onChange(VQ.HAS_TERRORISM_CONNECTION, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: hasTerrorismConnection === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: hasTerrorismConnection === false,
          },
        ]}
      />

      <RadioOptionsWithConfirm
        key={VQ.HAS_TERRORISM_JUSTIFIED}
        id={VQ.HAS_TERRORISM_JUSTIFIED}
        label={t('common:haveYouEverByAnyMeansOrMediumExp')}
        onClick={(question: IQuestion) => onChange(VQ.HAS_TERRORISM_JUSTIFIED, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: hasTerrorismJustified === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: hasTerrorismJustified === false,
          },
        ]}
      />

      <RadioOptionsWithConfirm
        key={VQ.HAS_WAR_CRIMES}
        id={VQ.HAS_WAR_CRIMES}
        label={t('common:inTimesOfEitherPeaceOrWarHaveYou')}
        onClick={(question: IQuestion) => onChange(VQ.HAS_WAR_CRIMES, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: hasWarCrimes === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: hasWarCrimes === false,
          },
        ]}
      />

      <RadioOptionsWithConfirm
        key={VQ.HAS_BAD_ACTIVITIES}
        id={VQ.HAS_BAD_ACTIVITIES}
        label={t('common:haveYouEngagedInAnyOtherActiviti')}
        onClick={(question: IQuestion) => onChange(VQ.HAS_BAD_ACTIVITIES, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: hasBadActivities === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: hasBadActivities === false,
          },
        ]}
      />

      <InputWithConfirm
        key={VQ.LANGUAGE}
        id={VQ.LANGUAGE}
        value={language}
        label={t('common:ifUkviNeedToInterviewYouWhatLang')}
        onChange={(evt: any) => {
          onChange(VQ.LANGUAGE, evt.currentTarget.value);
        }}
      />
    </QuestionPage>
  );
};
export default VisaPrepFormDeclarationsPage1;
